import { useEffect } from "react";
// import headerImage from "../../assets/header.jpg";
// import socaedLogo from '../../assets/conseil.jpg'

import { socials } from "../footer/data";
import AOS from "aos";
import "aos/dist/aos.css";
import "./header.css";

import Landing from "../Landing/Landing";

const Header = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <section id="header" className="bgimg">
      <div className="container header__container" data-aos="fade-in">
        <div className="landing">
          <Landing />

          <p className="landing_button">
           
            <h1 > Make your dream come true !</h1> 
           
          </p>
        </div>

        {/* <div className="header__socials">
          {socials.map((item) => (
            <a
              key={item.id}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.icon} 
            </a>
          ))}
        </div> */}
      </div>
    </section>
  );
};

export default Header;
